export default {"src":"/_next/static/media/badges-spring.4260ec61.svg","height":128,"width":98,"blurWidth":0,"blurHeight":0};